import React from 'react';
import Collapser from '../Collapser/Collapser';
import { HintEvent, OnChangeEvent } from '../events/EventProvider';
import useEvents from '../events/useEvents';

export type HintContent = {
  label: string;
  content: string[];
};

function Hint({
  id,
  hint,
  eventId,
  onHintToggle,
}: {
  id?: string;
  eventId?: string;
  hint?: HintContent;
  onHintToggle: (open: boolean) => void;
}): JSX.Element {
  const triggerEvent = useEvents<OnChangeEvent<HintEvent>>(eventId, 'Hint');

  const handleOnHintToggle = (open: boolean) => {
    triggerEvent({
      open,
    });
    onHintToggle(open);
  };

  if (hint)
    return (
      <Collapser
        label={hint.label}
        content={hint.content}
        onToggle={handleOnHintToggle}
        role="tooltip"
        contentId={id}
      />
    );

  return <></>;
}

export default Hint;
